import React, { useEffect, useState } from 'react'
import { useTrans } from 'hooks'
import { formatPrice } from 'utils'
import { ArrowRightLong } from 'react-components/atoms/Icons'
import { ImageBox, Button, Modal } from 'react-components/atoms'
import { useIsMobile } from 'hooks/useIsMobile'
import { useAnnullaOrdineMutation } from 'gql/graphql'
import { useRouter } from 'next/router'

const AreaPersonaleOrdineCard = (props) => {
  const { ordine = undefined, advanced = false, className = '' } = props

  const isMobile = useIsMobile()
  const t = useTrans()

  const [order, setOrder] = useState(ordine)

  const router = useRouter()
  const [showAnnullaModal, setShowAnnullaModal] = useState(false)

  const details = [
    { key: 'data_ordine', label: t('Data ordine'), value: order.data },
    { key: 'totale', label: t('Totale'), value: formatPrice(order.prezzoTotaleScontato) },
    {
      key: 'stato',
      label: t('Stato'),
      value: order.etichettaReso ? `${order.stato?.nome} - ${order.statusReso}` : order.stato?.nome,
    },
  ]

  const moreOrderLimit = isMobile ? 3 : 2

  const [annullaOrdine, { data: dataAnnullamento, loading, error }] = useAnnullaOrdineMutation()

  useEffect(() => {
    if (dataAnnullamento?.annullaOrdine?.status) {
      dataAnnullamento.annullaOrdine.order
      setOrder({ ...order, ...dataAnnullamento.annullaOrdine.order })
    }
  }, [dataAnnullamento])

  return ordine ? (
    <div
      className={`area-personale-ordine-card ${
        advanced ? 'area-personale-ordine-card--advanced' : ''
      } ${className ? ` ${className}` : ''}`}
    >
      <Modal
        open={showAnnullaModal}
        setOpen={() => {
          setShowAnnullaModal(false)
        }}
        closeButton
      >
        <h3
          className="modal__body__title"
          style={{ textAlign: 'center', marginBottom: '20px', fontSize: '30px' }}
        >
          {t("Stai per annullare l'ordine")}
        </h3>
        <div
          className="modal__body__text"
          style={{ textAlign: 'center', marginBottom: '20px' }}
          dangerouslySetInnerHTML={{
            __html: t("Sei sicuro di voler annullare l'ordine in questione?"),
          }}
        />
        <Modal.Buttons>
          <Button
            type="submit"
            label={t('Conferma')}
            onClick={() => {
              annullaOrdine({ variables: { orderId: order.pk } })
              setShowAnnullaModal(false)
            }}
          />
          <Button
            type="submit"
            label={t('Chiudi')}
            variant={'secondary'}
            onClick={() => {
              setShowAnnullaModal(false)
            }}
          />
        </Modal.Buttons>
      </Modal>

      <p className="area-personale-ordine-card__title">{t('Ordine #{0}', [order.pk])}</p>
      <div className="area-personale-ordine-card__main">
        <div className="area-personale-ordine-card__content">
          <div className="area-personale-ordine-card__details">
            {details.map((x) => (
              <div key={x.key} className="area-personale-ordine-card__detail">
                <span className="area-personale-ordine-card__detail-label">{x.label}</span>
                <span className="area-personale-ordine-card__detail-value">{x.value}</span>
              </div>
            ))}
          </div>
          {!!advanced && order.righeOrdine?.length > 0 && (
            <div className="area-personale-ordine-card__images">
              {order.righeOrdine
                .filter((x) => x.prodotto?.mainImage)
                .slice(0, moreOrderLimit)
                .map((x) => (
                  <ImageBox key={x.pk} src={x.prodotto.mainImage} maxWidth={70} maxHeight={88}>
                    {x.quantitaOrdinata > 1 && (
                      <span className="area-personale-ordine-card__images__quantity">
                        {x.quantitaOrdinata}
                      </span>
                    )}
                  </ImageBox>
                ))}
              {order.righeOrdine.filter((x) => x.prodotto).length > moreOrderLimit && (
                <ImageBox src="/images/ecommerce/ordini_more.png" maxWidth={70} maxHeight={88}>
                  <span className="area-personale-ordine-card__images__more">
                    + altri {order.righeOrdine.filter((x) => x.prodotto).length - moreOrderLimit}
                  </span>
                </ImageBox>
              )}
            </div>
          )}
        </div>
        <div className="area-personale-ordine-card__actions">
          {advanced && order.stato.chiave === 'spedito' && order.trackingUrl && (
            <Button
              variant="secondary"
              label={t('Traccia spedizione')}
              href={order.trackingUrl}
              className="area-personale-ordine-card__track"
              newPage
              external
            />
          )}
          {order?.annullabile && (
            <Button
              variant="secondary"
              label={t('Annulla ordine')}
              className="area-personale-ordine-card__track"
              onClick={() => setShowAnnullaModal(true)}
              loading={loading}
            />
          )}
          {order?.rendibile && (
            <Button
              variant="secondary"
              label={t('Rendi ordine')}
              className="area-personale-ordine-card__track"
              href={order.url.substr(-1) === '/' ? `${order.url}return/` : `${order.url}/return/`}
            />
          )}

          {order?.etichettaReso && (
            <Button
              variant="ghost"
              label={t('Stampa etichetta reso')}
              icon={<ArrowRightLong />}
              iconPos="right"
              className="area-personale-ordine-card__cta"
              download
              external
              newPage
              href={order.etichettaReso}
            />
          )}
          <Button
            variant="ghost"
            label={t('Vedi dettagli')}
            icon={<ArrowRightLong />}
            iconPos="right"
            className="area-personale-ordine-card__cta"
            href={order.url}
          />
        </div>
      </div>
    </div>
  ) : (
    <></>
  )
}

export default AreaPersonaleOrdineCard
